let i = 0;

export default {
    bind: function (el: HTMLElement, binding: any) {
        if (!el || !el.dataset)
            return;

        updateTitleTooltipElement(el, binding.value);
        el.addEventListener("mouseenter", onEnter);
        el.addEventListener("mouseleave", onLeave);
    },
    update: function (el: HTMLElement, binding: any) {
        updateTitleTooltipElement(el, binding.value);
    },
    unbind: function (el: HTMLElement) {
        if (el.dataset.titleTooltipId == null)
            throw "Could not get tooltip ID";

        let tt = document.getElementById(el.dataset.titleTooltipId);
        if (tt && tt.parentElement) {
            tt.parentElement.removeChild(tt);
        }
    }
}

document.addEventListener('keydown', e => {
    if (e.key === "Escape" || e.key === "Esc") {
        removeTitleTooltip();
    }
});

let timeouts = new Map<string, NodeJS.Timeout>();

function onEnter(ev: MouseEvent) {
    let el = <HTMLElement> ev.target;
    if (el.dataset.titleTooltipId && el.dataset.tooltipTitle) {
        let id = el.dataset.titleTooltipId;
        let title = el.dataset.tooltipTitle;
        let timeout = setTimeout(() => addTitleTooltip(id, el, title), 500);
        timeouts.set(id, timeout);
    }
}

function onLeave(ev: MouseEvent) {
    let el = <HTMLElement> ev.target;
    if (el.dataset.titleTooltipId) {
        let id = el.dataset.titleTooltipId;
        let timeout = timeouts.get(id);
        if (timeout != null) {
            clearTimeout(timeout);
        }
    }

    removeTitleTooltip();
}

function updateTitleTooltipElement(el: HTMLElement, title: string) {
    if (!el || !el.dataset)
        return;

    let elTooltipId = "tooltip-title-" + i;
    i += 1;
    if (!el.dataset.titleTooltipId)
        el.dataset.titleTooltipId = elTooltipId;
    el.dataset.tooltipTitle = title;
}

function addTitleTooltip(elTooltipId: string, el: HTMLElement, title: string) {
    removeTitleTooltip();

    let titleElement = document.createElement("DIV");
    titleElement.className = "tooltip-title";
    titleElement.id = elTooltipId;

    let arrowElement = document.createElement("DIV");
    arrowElement.className = "tooltip-title__arrow";

    let textElement = document.createElement("DIV");
    textElement.textContent = title;
    textElement.className = "tooltip-title__text";

    titleElement.appendChild(textElement);
    titleElement.appendChild(arrowElement);

    document.body.appendChild(titleElement);

    let tooltipPosition: TooltipPosition = getTooltipPosition(el);
    titleElement.className += " " + tooltipPosition;
    el.setAttribute("aria-describedby", titleElement.id);

    // Timeout is here because the browser doesn't know the width of the titleElement until it's been rendered
    setTimeout(() => {
        let titlePosition = titleElement.getBoundingClientRect();
        let x: number;
        let y: number;
        let elementPosition = el.getBoundingClientRect();

        if (tooltipPosition === TooltipPosition.Right) {
            x = Math.round(window.pageXOffset + elementPosition.right - 5);
            y = Math.round(window.pageYOffset + elementPosition.top + elementPosition.height / 2  - titlePosition.height / 2);
        }
        else if (tooltipPosition === TooltipPosition.Left) {
            x = Math.round(window.pageXOffset + elementPosition.left + elementPosition.width / 2  - titlePosition.width - 3);
            y = Math.round(window.pageYOffset + elementPosition.top + elementPosition.height / 2  - titlePosition.height / 2);
        }
        else if (tooltipPosition === TooltipPosition.Below) {
            x = Math.round(window.pageXOffset + elementPosition.left + elementPosition.width / 2 - (titlePosition.width / 2));
            y = Math.round(window.pageYOffset + elementPosition.bottom);
        }
        else {
            x = Math.round(window.pageXOffset + elementPosition.left + elementPosition.width / 2 - (titlePosition.width / 2));
            y = Math.round(window.pageYOffset + elementPosition.top) - titlePosition.height + 8;
        }

        titleElement.className += " " + tooltipPosition;
        titleElement.style.transform = `translate(${x}px,${y}px)`;
    }, 0);
}

enum TooltipPosition {
    Above = "above",
    Below = "below",
    Left = "left",
    Right = "right"
}

function getTooltipPosition(targetElement: HTMLElement) {
    let windowWidth = window.innerWidth;
    const horizontalGutter = 150;
    const verticalGutter = 50;

    let elementPosition = targetElement.getBoundingClientRect();
    let targetX = elementPosition.left + elementPosition.width / 2;
    let targetY = elementPosition.top;

    if (targetX < horizontalGutter) {
        return TooltipPosition.Right;
    }
    else if (windowWidth - targetX < horizontalGutter) {
        return TooltipPosition.Left;
    }
    else if (targetY < verticalGutter) {
        return TooltipPosition.Below;
    }
    else {
        return TooltipPosition.Above;
    }
}

function removeTitleTooltip() {
    let elements = document.querySelectorAll(".tooltip-title");
    for (let i = 0; i < elements.length; i++) {
        let e = <HTMLElement> elements.item(i);
        e.style.opacity = "0";
        setTimeout(() => {
            if (e && e.parentElement)
                e.parentElement.removeChild(e)
        }, 200);
    }
}